import { EventEmitter, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from './language.service';
var LanguageComponent = /** @class */ (function () {
    function LanguageComponent(route, translateService, languageService) {
        this.route = route;
        this.translateService = translateService;
        this.languageService = languageService;
        this.containerIsHovered = new EventEmitter();
    }
    LanguageComponent.prototype.ngOnInit = function () {
        this.language = this.languageService.defineLanguage(localStorage.getItem('lang'));
        this.translateService.addLangs(['es', 'us', 'br']);
        this.translateService.use(this.language);
    };
    return LanguageComponent;
}());
export { LanguageComponent };
